export default __webpack_public_path__ + "static/media/013-kaaba.c5d880dc.svg";